module.exports = __webpack_public_path__ + "media/images/icons/flags/KN-8076338356cabc5598efb3360cda7332.svg";